'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var selectOnClick = function () {
  function selectOnClick() {
    var _this = this;

    _classCallCheck(this, selectOnClick);

    this.link = function (scope, element, attrs) {
      element.on('click', _this.select);
      element.on('blur', _this.blur);
    };

    this.$onDestroy = function () {
      $element.off('click', this.select);
      $element.off('blur', this.blur);
    };

    this.restrict = 'A';
    this.scope = {};
    this.focusedElement = null;
  }

  _createClass(selectOnClick, [{
    key: 'select',
    value: function select() {
      if (this.focusedElement != this) {
        this.select();
        this.focusedElement = this;
      }
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.focusedElement = null;
    }
  }], [{
    key: 'create',
    value: function create() {
      return new (Function.prototype.bind.apply(selectOnClick, [null].concat(Array.prototype.slice.call(arguments))))();
    }
  }]);

  return selectOnClick;
}();

selectOnClick.create.$inject = [];

exports.selectOnClick = selectOnClick;


//////////////////
// WEBPACK FOOTER
// ./common/directives/select-onclick/select-onclick.js
// module id = 474
// module chunks = 0